<template>
  <v-card :loading="showDialogProgress" :disabled="showDialogProgress">
  <div class="MissionRequest">
    <box class="" :title="this.$t('nav-request-mission')">
      <div class="px-3 pt-2">
        <v-form ref="form" v-model="form">
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("missionType") }} : </label>
                </v-col>
                <v-col>
                  <v-select
                    :rules="[$rules.required]"
                    hide-details
                    v-model="missionParams.missionType"
                    :items="missionTypes"
                    :label="$t('missionType')"
                    item-text="Name"
                    item-value="Code"
                    return-object
                    dense
                    solo
                    v-on:change="changeMissionType"
                    class="my-auto py-0"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("cityName") }} : </label>
                </v-col>
                <v-col>
                  <v-select
                    :rules="[$rules.required]"
                    hide-details
                    v-model="missionParams.city"
                    :items="missionCities"
                    :label="$t('cityName')"
                    item-text="Name"
                    item-value="Code"
                    return-object
                    dense
                    solo
                    v-on:change="changeMissionCity"
                    class="my-auto py-0"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("fromDate") }} : </label>
                </v-col>
                <v-col>
                  <dialog-date-picker
                    :label="$t('fromDate') + ':'"
                    :initDate="initBeginDate"
                    @dateResult="bDate"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("toDate") }} : </label>
                </v-col>
                <v-col>
                  <dialog-date-picker
                    :label="$t('toDate') + ':'"
                    :initDate="initEndDate"
                    @dateResult="eDate"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2" v-if="showMissionTime">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("fromTime") }} : </label>
                </v-col>
                <v-col>
                  <dialog-time-picker
                    :label="$t('fromTime') + ':'"
                    :initTime="initBeginTime"
                    @dateResult="bTime"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("toTime") }} : </label>
                </v-col>
                <v-col>
                  <dialog-time-picker
                    :label="$t('toTime') + ':'"
                    :initTime="initEndTime"
                    @dateResult="eTime"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("missionLocation") }} : </label>
                </v-col>
                <v-col>
                  <v-textarea
                    solo
                    dense
                    hide-details=""
                    v-model="missionParams.Place"
                    auto-grow
                    :rules="[$rules.required]"
                    :placeholder="$t('missionLocation')"
                    rows="1"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("description") }} : </label>
                </v-col>
                <v-col>
                  <v-textarea
                    solo
                    dense
                    hide-details=""
                    ref="description"
                    v-model="missionParams.Description"
                    auto-grow
                    :placeholder="$t('description')"
                    rows="1"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showWorkCalndar = !showWorkCalndar">{{
            $t("workCalendar")
          }}</v-btn>
          <v-btn color="primary" v-if="visibleBtn"  :loading="isLoading" @click="showIntervalIo">{{
              $t("nav-interval-io")
            }}</v-btn>
          <v-btn
            color="primary"
            :disabled="!form"
            :loading="isLoading"
            @click="addMission"
            >{{ $t("missionRegistration") }}</v-btn
          >
          
        </v-card-actions>
      </div>
    </box>
    <IntervalIOList
      ref="intervalIOList"
      class="py-2"
      :visible="IntervalIOListVisibility"
    />

    <WorkCalendar :showWorkCalndar="showWorkCalndar" :perno="this.perno" />
  </div>
  </v-card>
</template>

<script>
import IntervalIOList from "../../components/io/IntervalIO/IntervalIOList.vue";
import WorkCalendar from "../../components/request/WorkCalendar.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import DateUtils from "../../utils/DateUtils";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    WorkCalendar,
    DialogDatePicker,
    DialogTimePicker,
    IntervalIOList,
  },
  mounted() {
    this.getMissionTypes();
    this.getMissionCities();
    this.checkDescriptionRules();
  },
  data() {
    return {
      args: {},
      missionParams: {},
      missionTypes: [],
      missionCities: [],
      showMissionTime: false,
      showWorkCalndar: false,
      showDialogProgress: false,
      form: false,
      isLoading: false,
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      beginTime: "",
      endTime: "",
      initBeginTime: null,
      initEndTime: null,
      perno: "",
      visibleBtn:false,
      IntervalIOListVisibility:false,
      countResult:0,
    };
  },
  methods: {
    getArgs() {
      this.args = this.$route.params.details;
      if (this.args) {
        this.loadRegistration(this.args);
        this.countResult=1;
      }

      if (this.args && this.args.selectedPerno) {
        this.perno = this.args.selectedPerno;
      }

      var selectedDate = this.$route.query.SD;
      if (selectedDate) {
        this.initBeginDate = this.beginDate = selectedDate;
        this.initEndDate = this.endDate = selectedDate;
      }
    },
    loadRegistration(args) {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(args.PageNo));
      params.append("dbkind", args.DBKind);
      params.append("year", args.Year);
      params.append("perno", args.selectedPerno || "");
      this.$store
        .dispatch("GetMissionDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if ( this.countResult > 0) {
              this.details = result.data[0];
              this.details.Year = args.Year;
              this.ShowMissionDetailForEdit(this.details);
              this.countResult=0;
            }
          }
        });
    },
    ShowMissionDetailForEdit(details) {
      this.missionParams.PageNo = details.PageNo.trim();
      this.missionParams.Description = details.UserDescription;
      this.missionParams.Place = details.Location;

      let missionCity = this.missionCities.find(
        (item) => item.Code == details.City
      );
      if (missionCity) {
        this.changeMissionCity(missionCity);
      }

      let missionType = this.missionTypes.find(
        (item) => item.Code == details.Type
      );
      if (missionType) {
        this.changeMissionType(missionType);
      }

      this.initBeginDate = this.beginDate =
        details.Year + "/" + details.BeginDate;
      this.initEndDate = this.endDate = details.Year + "/" + details.EndDate;
      if (details.IsDaily == false) {
        this.initBeginTime = this.beginTime = details.BeginTime;
        this.initEndTime = this.endTime = details.EndTime;
      }
    },
    bDate(date) {
      //debugger
      this.beginDate = date;
      if(this.missionParams.missionType.IsDaily==0){
        this.initEndDate =date;
      } 
    },
    eDate(date) {
      this.endDate = date;
    },
    bTime(date) {
      this.beginTime = date;
    },
    eTime(date) {
      this.endTime = date;
    },
    getMissionTypes() {
      this.$store.dispatch("GetWebMissionTypeList").then((response) => {
        if (response.type === "success") {
          this.missionTypes = response.data;
          if (this.missionTypes.length > 0) {
            this.missionParams.missionType = this.missionTypes[0];
            this.showMissionTime = this.missionTypes[0].IsDaily == 0;

            this.getArgs();
          }
        }
      });
    },
    getMissionCities() {
      this.$store.dispatch("GetMissionCityList").then((response) => {
        if (response.type === "success") {
          this.missionCities = response.data;
          if (this.missionCities.length > 0) {
            var defaultCityCodeToInt=parseInt(localStorage.getItem('CityCode'));
            if(defaultCityCodeToInt!=0){
              //debugger
              var valObj =this.missionCities.find(s=>s.Code===defaultCityCodeToInt); 
              console.log('result obj'+valObj)

              // this.selectedCity = this.defaultCityCode;
             this.missionParams.city = valObj;
            }
            else{
              this.missionParams.city = this.missionCities[0];

            }
            
          }
        }
      });
    },
    changeMissionType(item) {
      //debugger
      this.missionParams.missionType = item;
      this.IntervalIOListVisibility = false;
      if (item.IsDaily == 0) {
        this.showMissionTime = true;
        this.visibleBtn=true;
        this.getArgs()
        this.initEndDate=this.beginDate
      } else {
        this.showMissionTime = false;
        this.visibleBtn=false;
      }
    },
    changeMissionCity(item) {
      this.missionParams.city = item;
    },
    async addMission() {
      //debugger
      this.showDialogProgress = true;

      
      //console.log(this.beginDate);
      //console.log(this.endDate);
      if (
        this.missionParams.Description &&
        this.missionParams.Description.length > 230
      ) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "ثبت علت ماموریت، بیش از 230 کارکتر مجاز نمی باشد",
        });
        this.showDialogProgress = false;
        return;
      }

      if (this.missionParams.Place && this.missionParams.Place.length > 30) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "ثبت محل ماموریت، بیش از 30 کارکتر مجاز نمی باشد",
        });
        this.showDialogProgress = false;
        return;
      }

      if (!this.beginDate || !this.endDate) {
        //debugger
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("eosWinKartWebResource.wrongDate"),
        });
        this.showDialogProgress = false;
        return;
      }

      if (
        DateUtils.getYearFromDate(this.beginDate) !=
        DateUtils.getYearFromDate(this.endDate)
      ) {
        //debugger
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("eosWinKartWebResource.dateMustbeinSameYear"),
        });
        this.showDialogProgress = false;
        return;
      }

      //ماموریت ساعتی
      if (this.missionParams.missionType.IsDaily == 0) {
        //empty time
        //console.log(this.beginTime,this.endTime);
        if (!this.beginTime || !this.endTime) {
          //debugger
          this.$EosToast.show({
            type: EosToastType.warning,
            msg: this.$t("eosWinKartWebResource.wrongTime"),
          });
          this.showDialogProgress = false;
          return;
        }

        //CompareTimes
        if (
          this.beginDate + " " + this.beginTime >=
          this.endDate + " " + this.endTime
        ) {
          //debugger
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("eosWinKartWebResource.CompareTimes"),
          });
          this.showDialogProgress = false;
          return;
        }

        if (this.beginDate == this.endDate) {
          if (this.beginTime >= this.endTime) {
            //debugger
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("eosWinKartWebResource.CompareTimes"),
            });
            this.showDialogProgress = false;
            return;
          }
          this.showDialogProgress = false;
        }

        //over 24 hours
        var moment = require("jalali-moment");
        var a = moment(
          this.beginDate + "-" + this.beginTime,
          "jYYYY/jMM/jDD-hh:mm"
        ).locale("fa");

        var b = moment(
          this.endDate + "-" + this.endTime,
          "jYYYY/jMM/jDD-hh:mm"
        ).locale("fa");

        var diff = b.diff(a, "hours");
        if (diff > 24) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "مدت زمان ماموریت ساعتی بیش از 24 ساعت است",
          });
          this.showDialogProgress = false;
          return;
        }
      } else {
        //ماموریت روزانه
        this.beginTime = "";
        this.endTime = "";
      }

      const params = new URLSearchParams();
      params.append("BeginDate", this.beginDate);
      params.append("EndDate", this.endDate);
      params.append("BeginTime", this.beginTime);
      params.append("EndTime", this.endTime);
      params.append("Description", this.missionParams.Description || "");
      params.append("MissionType", this.missionParams.missionType.Code);
      params.append("CityCode", this.missionParams.city.Code);
      params.append("Place", this.missionParams.Place || "");
      params.append("PageNo", this.missionParams.PageNo || "");
      if (this.args?.selectedPerno) {
        params.append("perno", this.args.selectedPerno);
      }

      this.$store.dispatch("AddMission", { params }).then(async (result) => {
        if (result.type === "success") {
          //IsDaily
          if (this.missionParams.missionType.IsDaily == 1) {
            try {
              //debugger
              //در صورتی که ماموریت روزانه باشد و تیک آیتم "امکان ثبت ساعت های ماموریت وجود داشته باشد" در تنظیمات سیستم
              //تیک خورده باشد
              // امکان ثبت ساعت های برگه ماموریت روزانه وجود خواهد داشت و به صفحه مربوط
              // انتقال به صفحه مربوطه انجام خواهد گرفت
              var SaveMissionTime = "";
              await this.$store
                .dispatch("readwebkartsetting")
                .then((result) => {
                  if (result.type === "success") {
                    SaveMissionTime = result.data.SaveMissionTime;
                  }
                });
              if (SaveMissionTime == "1") {
                //addMissionHour
                var perno = this.$store.state.auth.auth.username;
                if (this.args?.selectedPerno) {
                  perno = this.args.selectedPerno;
                }
                this.$router.push({
                  name: "addMissionHour",
                  query: {
                    pid: perno,
                    bd: this.beginDate,
                    ed: this.endDate,
                    t: this.missionParams.missionType.Code,
                    y: this.beginDate.substring(0, 4),
                  },
                });
              } else {
                // در غیر این صورت امکان ثبت ساعت های ماموریت روزانه وجود نخواهد داشت
                // و به صفحه آرشیوبرگه های ماموریت انتقال انجام خواهد گرفت
                this.$EosToast.show({
                  type: EosToastType.success,
                  msg: this.$t("msg-registration-success", {
                    opName: this.$t("nav-request-mission"),
                  }),
                });

                this.$refs.form.reset();

                if (this.missionParams.PageNo && this.args && this.args.from) {
                  this.$router.push({ name: this.args.from });
                } else {
                  this.$router.push({ name: "request-mission-archive" });
                }
              }
            } catch (error) {
              this.$store.dispatch("readwebkartsetting").then((result) => {
                if (result.type === "success") {
                  if (result.data.SaveMissionTime == "1") {
                    //editMissionHour
                    var perno = this.$store.state.auth.auth.username;
                    if (this.args?.selectedPerno) {
                      perno = this.args.selectedPerno;
                    }
                    this.$router.push({
                      name: "addMissionHour",
                      query: {
                        pid: perno,
                        bd: this.beginDate,
                        ed: this.endDate,
                        t: this.missionParams.missionType.Code,
                        y: this.beginDate.substring(0, 4),
                      },
                    });
                  } else {
                    this.$EosToast.show({
                      type: EosToastType.success,
                      msg: this.$t("msg-registration-success", {
                        opName: this.$t("nav-request-mission"),
                      }),
                    });

                    this.$refs.form.reset();

                    if (
                      this.missionParams.PageNo &&
                      this.args &&
                      this.args.from
                    ) {
                      this.$router.push({ name: this.args.from });
                    }
                  }
                }
              });
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("msg-registration-success", {
                opName: this.$t("nav-request-mission"),
              }),
            });

            this.$refs.form.reset();

            this.$router.push({ name: "request-mission-archive" });
            this.showDialogProgress = false;
          }
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || "error",
          });
          this.showDialogProgress = false;
        }
      });
    },
    checkDescriptionRules() {
      var IsCommentRequired =
        this.$store.state.settings.settings.IsCommentRequired;
      if (IsCommentRequired == 1) {
        this.$refs.description.rules = [this.$rules.required];
      }
    },
    showIntervalIo(){
      this.IntervalIOListVisibility = true;
      this.$refs.intervalIOList.showIntervalDays(2, this.beginDate);
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 95px;
}
</style>